import { AccessSessionClientModel, useListAccessSessions } from '@apono/client-app-sdk';
import { Flags } from '@common/utils/flags/feature-flags';
import { useFlagFixed } from '@common/utils/flags/use-flag-fixed';
import { LoadingButton } from '@mui/lab';
import { Button, Divider, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { STATUS_FILTER_PARAM } from './filters/StatusFilter';

export function LoadMoreAccessSessions({
  integrationId,
  onLoadSessions,
  initOffset = 0,
}: {
  integrationId: string;
  initOffset?: number;
  onLoadSessions: (additionalSessions: AccessSessionClientModel[]) => void;
}) {
  const [clicked, setClicked] = useState(false);

  if (clicked) {
    return (
      <AccessSessionsHandler integrationId={integrationId} onLoadSessions={onLoadSessions} initOffset={initOffset} />
    );
  }

  return (
    <>
      <Divider />
      <Stack direction="row" justifyContent="center" alignItems="center" sx={{ padding: 1 }}>
        <Button onClick={() => setClicked(true)}>Load more</Button>
      </Stack>
    </>
  );
}

function AccessSessionsHandler({
  integrationId,
  onLoadSessions,
  initOffset = 0,
}: {
  integrationId: string;
  initOffset?: number;
  onLoadSessions: (additionalSessions: AccessSessionClientModel[]) => void;
}) {
  const { isEnabled: isJitConnectedEnabled } = useFlagFixed(Flags.JIT_CONNECT);

  const [queryParams] = useSearchParams();
  const status = queryParams.get(STATUS_FILTER_PARAM) ?? undefined;

  const { data, isFetching, fetchNextPage } = useListAccessSessions({
    integrationId: [integrationId],
    skip: initOffset,
    includeDisconnected: isJitConnectedEnabled,
    status: status ? [status] : undefined,
  });

  useEffect(() => {
    onLoadSessions(data?.pages?.flatMap((page) => page.data) || []);
  }, [data, onLoadSessions]);

  return (
    <>
      <Divider />
      <Stack direction="row" justifyContent="center" alignItems="center" sx={{ padding: 1 }}>
        <LoadingButton loading={isFetching} onClick={() => fetchNextPage()}>
          Load more
        </LoadingButton>
      </Stack>
    </>
  );
}
